import { render } from "./Fatture.vue?vue&type=template&id=0d70fc65&scoped=true"
import script from "./Fatture.vue?vue&type=script&lang=js"
export * from "./Fatture.vue?vue&type=script&lang=js"

import "./Fatture.vue?vue&type=style&index=0&id=0d70fc65&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d70fc65"]])

export default __exports__